<div
  class="party-select"
  [class.party-select-admin-padding]="displayDropDown"
  (click)="displayDropDown && toggleSelect()"
>
  <div *ngIf="displayDropDown" class="image-container-admin">
    <img
      *ngIf="displayImage"
      class="party-name"
      src="{{ imageSource }}"
      alt="{{ selectedParty }}"
      (error)="displayImage = false"
    />
    <span *ngIf="!displayImage" class="selected-party-name party-name">{{
      selectedPartyName
    }}</span>
  </div>

  <div *ngIf="!displayDropDown" class="image-container">
    <img
      *ngIf="displayImage"
      src="{{ imageSource }}"
      alt="{{ selectedParty }}"
      (error)="displayImage = false"
    />
    <span *ngIf="!displayImage" class="selected-party-name party-name">{{
      selectedPartyName
    }}</span>
  </div>

  <mat-form-field *ngIf="displayDropDown" class="party-select-admin">
    <mat-select
      #partySelect
      panelClass="select-panel"
      data-cy="party-select"
      [value]="selectedParty"
      [(ngModel)]="selectedParty"
      (selectionChange)="newPartySelected($event)"
      (click)="$event.stopPropagation()"
    >
      <mat-optgroup
        *ngFor="let partyDropDown of partiesDropDown; trackBy: trackByIndex"
        [label]="partyDropDown.groupName"
      >
        <mat-option
          *ngFor="let party of partyDropDown.parties; trackBy: trackByIndex"
          [attr.data-cy]="party.name + '-option'"
          [value]="party"
        >
          {{ party.name }}
        </mat-option>
      </mat-optgroup>
    </mat-select>
  </mat-form-field>
</div>
